import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import { Provider } from 'react-redux';
import { store } from './Redux/Store';
import * as Sentry from "@sentry/react";
import ErrorBoundary from './components/ErrorBoundry';





// console.log("NODE_ENV:", process.env.NODE_ENV);
// console.log("REACT_APP_SENTRY_DSN:", process.env.REACT_APP_SENTRY_DSN);

// 🔍 Initialize Sentry with debug mode ON
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.5,
    environment: process.env.NODE_ENV,
    // debug: true, // 👈 VERY IMPORTANT
  });

  // console.log("✅ Sentry initialized successfully");
} else {
  console.error("❌ Sentry DSN is missing!");
}

// 🔍 Test Sentry immediately
Sentry.captureMessage("Sentry test message from app start");
const originalFetch = window.fetch;

window.fetch = async (...args) => {
  try {
    const response = await originalFetch(...args);

    if (!response.ok) {
      const error = new Error(`API Error: ${response.status}`);
      error.response = response;
      Sentry.captureException(error);
    }

    return response;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
 
    <Provider store={store}>
      {/* <ErrorBoundary> */}
      <App />
      {/* </ErrorBoundary> */}
    </Provider>
   

  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
